/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2022
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import { useEffect, useState } from 'react';
import { codeLanguages } from 'code-snippets/constants';
import { useApi } from '../contexts/ApiHandler';

const useAsyncAPICodeSnippetLanguages = (schemaType, encodingType) => {
  const { apiHandler } = useApi();
  const [availableLanguages, updateAvailableLanguages] = useState([]);

  useEffect(() => {
    // Iterate through the list of languages, removing any incompatible languages for a particular
    // schema type.
    updateAvailableLanguages(
      Object.values(codeLanguages).filter((language) => {
        // kafka console consumer doesn't work with Avro schemas that are not JSON encoded.
        switch (language) {
          case codeLanguages.kafkacat:
          case codeLanguages.consoleConsumer:
            return apiHandler.isAvroSchema(schemaType) && encodingType !== 'application/json' ? false : true;
          default:
            return true;
        }
      })
    );
  }, [schemaType, apiHandler, encodingType]);

  return availableLanguages;
};

export { useAsyncAPICodeSnippetLanguages };
